<div *ngIf='componentReady' class='BlockedDateRules'>
  <div *ngIf='canAdd' class='BlockedDateRules__header d-flex justify-content-end'>
    <app-button [Click]='addButtonProperties.onClick' [color]='addButtonProperties.color'
                [size]='addButtonProperties.size'
                [text]='addButtonProperties.text'></app-button>
  </div>
  <div class='BlockedDatesRules__body'>
    <app-table [columns]='tableColumns' [dataSourceParams]='dataSourceParams' [dataSource]='dataSource'></app-table>
  </div>
</div>